// extracted by mini-css-extract-plugin
export var actionButton = "_7i-1";
export var actionButtons = "_7i-2";
export var actions = "_7i-0";
export var aiUnread = "_7i-10";
export var alignCenter = "_7i-h";
export var backWrapper = "_7i-3";
export var cellContainer = "_7i-4";
export var checkboxContainer = "_7i-5";
export var contentContainer = "_7i-6";
export var contentHeader = "_7i-8";
export var conversationsTableWrapper = "_7i-s";
export var draftReplyBadgeContainer = "_7i-m";
export var dropdownItem = "_7i-b";
export var dropdownItemsContainer = "_7i-a";
export var dropdownTitle = "_7i-c";
export var errorIcon = "_7i-7";
export var filter = "_7i-d";
export var gray = "_7i-i";
export var headerActionButtons = "_7i-e";
export var headerCheckboxContainer = "_7i-f";
export var icon = "_7i-j";
export var menuContainer = "_7i-k";
export var noMoreTicketsIcon = "_7i-12";
export var noMoreTicketsSubText = "_7i-13";
export var oneLine = "_7i-l";
export var optionsButton = "_7i-n";
export var plus = "_7i-o";
export var portalButtonsWrapper = "_7i-g";
export var red = "_7i-p";
export var scrolledTop = "_7i-9";
export var search = "_7i-q";
export var selectedConversationsCount = "_7i-r";
export var spinner = "_7i-t";
export var strong = "_7i-u";
export var summaryCell = "_7i-v";
export var tableContainer = "_7i-11";
export var tagContainer = "_7i-w";
export var threeDots = "_7i-x";
export var twoLines = "_7i-y";
export var unread = "_7i-z";